import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/components/PageHeader";
import { GitFork } from "lucide-react";
import { EmptyState } from "@/components/EmptyState";

export const Route = createFileRoute("/_auth/sire-registry/")({
  component: TagBucket,
});

function TagBucket() {
  return (
    <>
      <PageHeader title="Sire Registry" />
      <main className="h-full overflow-y-auto bg-slate-100 p-6">
        <EmptyState
          title="Sire Registry"
          description="This page isn't available yet, but it's part of our roadmap. It will help you manage sires, track conception rates, and monitor calves and cows served with ease."
          Icon={GitFork}
        />
      </main>
    </>
  );
}
